
import React from 'react';
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface DemoModeToggleProps {
  isDemoMode: boolean;
  onToggle: (enabled: boolean) => void;
}

export const DemoModeToggle: React.FC<DemoModeToggleProps> = ({ 
  isDemoMode, 
  onToggle 
}) => {
  return (
    <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg border">
      <div className="flex items-center gap-3">
        <div className="flex items-center space-x-2">
          <Switch
            id="demo-mode"
            checked={isDemoMode}
            onCheckedChange={onToggle}
          />
          <Label htmlFor="demo-mode" className="font-medium">
            Demo Mode
          </Label>
        </div>
        <Badge variant={isDemoMode ? "default" : "secondary"}>
          {isDemoMode ? "Demo Data" : "Live Data"}
        </Badge>
      </div>
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <Info className="h-4 w-4 text-muted-foreground" />
          </TooltipTrigger>
          <TooltipContent className="max-w-xs">
            <p>
              {isDemoMode 
                ? "Showing mock candidate data for demonstration purposes. Toggle off to use real candidate matching." 
                : "Using real candidate data from your database. Toggle on to see demo candidates with sample matching scores."
              }
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
